var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "152.11875px",
    height: "167.16875px",
    viewBox: "0 0 152.11875 167.16875",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.58125,0 C98.7224265,0 117.48125,18.7597659 117.48125,41.8970099 C117.48125,65.0402341 98.7224265,83.8 75.58125,83.8 C52.4400735,83.8 33.68125,65.0402341 33.68125,41.8970099 C33.68125,18.7537858 52.4459559,0 75.58125,0 L75.58125,0 Z M57.50625,94.18125 L94.6125,94.18125 C126.375,94.18125 152.11875,119.5 152.11875,150.74375 L152.11875,154.3875 C152.11875,166.7 126.36875,167.16875 94.6125,167.16875 L57.50625,167.16875 C25.74375,167.16875 0,167.15 0,154.3875 L0,150.74375 C0,119.5 25.74375,94.18125 57.50625,94.18125 L57.50625,94.18125 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.d94d49e38ad77877cca517d3dbb555ae.svg";
export { ForwardRef as ReactComponent };